import { render, staticRenderFns } from "./vendor-legal-dokumen.vue?vue&type=template&id=20bb8850&scoped=true&"
import script from "./vendor-legal-dokumen.vue?vue&type=script&lang=js&"
export * from "./vendor-legal-dokumen.vue?vue&type=script&lang=js&"
import style0 from "./vendor-legal-dokumen.vue?vue&type=style&index=0&id=20bb8850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bb8850",
  null
  
)

export default component.exports